import { createComponent as _$createComponent } from "solid-js/web";
import { createPlaneViewerSurface } from "../shell/plane-viewer-surface.ts";
import { PlaneViewerInset } from "../planes/PlaneViewerInset.tsx";
import { ViewerEffectsControls } from "../planes/ViewerEffectsControls.tsx";
import { ScreenShell } from "../shell/ScreenShell.tsx";
import { createPersistedFlightSettings } from "../flight/persisted-settings.ts";

/**
 * `/planes` — VIEW AIRPLANES, in the shell (AD-009). Same one-line-of-wiring
 * shape as `Missions.tsx`/`Career.tsx`: the flow lives in
 * `shell/model/plane-viewer-model.ts`, the screen in
 * `shell/model/plane-viewer-screens.ts`, and the parked aeroplane on its
 * aerodrome is `planes/parked-preview.ts` composited through
 * `PlaneViewerInset`.
 *
 * The settings come from `createPersistedFlightSettings()` — the same helper
 * every flying route uses, against the same storage keys — so ENHANCED MODELS
 * chosen here is ENHANCED MODELS in the air, which is the point of putting the
 * toggles on an inspection screen. Only `effects` is read; the audio, cockpit
 * and stick groups it also loads cost one `localStorage` read apiece and keep
 * this route from having a bespoke loader to drift.
 */
export function ViewAirplanes() {
  const controller = createPlaneViewerSurface();
  const settings = createPersistedFlightSettings();
  return _$createComponent(ScreenShell, {
    controller: controller,
    label: "View airplanes",
    inset: box => _$createComponent(PlaneViewerInset, {
      box: box,
      surface: controller,
      get effects() {
        return settings.effects;
      }
    }),
    overlay: () => _$createComponent(ViewerEffectsControls, {
      get settings() {
        return settings.effects();
      },
      get onChange() {
        return settings.writeEffects;
      }
    })
  });
}